/**
 * MeetingFileService
 * Service for MeetingFile entity operations
 * Route: api/meetingfiles
 * Controller: MeetingFilesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingFileService
 * Handles meeting file CRUD operations
 * Maps to /api/meetingfiles endpoint
 */
export class MeetingFileService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingFileService.DEFAULT_SERVICE_PATH,
            basePath: MeetingFileService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingFileService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingFileService.BASE_PATH = 'api/meetingfiles';
//# sourceMappingURL=MeetingFileService.js.map